import AppConfig from "../services/AppConfig";

let isIframe = false;
if (window.top != window.self) {
    isIframe = true;
}

class IframeUtils {

    static redirect(url: string) {
        if (isIframe) {
            if (AppConfig.isNativeFrame() && IframeUtils.redirectTop(url)) {
                return;
            }
            if (AppConfig.isNativeMobile() || AppConfig.isNativeFullMobile()) {
                IframeUtils.notifyNativeRedirect(url);
            }
            let message = {type: 'RELOAD_PARENT', url: url};
            window.parent.postMessage(message, "*");
        } else {
            window.location.href = url;
        }
    }

    static redirectTop(url: string) {
        try {
            window.top!.location.href = url;
            return true;
        } catch (e) {
            console.warn("top navigation blocked, falling back to RELOAD_PARENT", e);
            return false;
        }
    }

    static notifyNativeRedirect(url: string) {
        const message = {type: 'RELOAD_PARENT', url};

        // React Native WebView
        if ((window as any).ReactNativeWebView) {
            (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
            return;
        }

        // Native Android WebView
        if ((window as any).AndroidApp?.reloadParent) {
            (window as any).AndroidApp.reloadParent(url);
        }
    }

    static notifyUrlChange(url: string) {
        const message = {type: 'URL_CHANGED', url};

        // React Native WebView
        if ((window as any).ReactNativeWebView) {
            (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
            return;
        }

        // Native Android WebView
        if ((window as any).AndroidApp?.notifyUrlChange) {
            (window as any).AndroidApp.notifyUrlChange(url);
            return;
        }

        // Iframe
        if (isIframe) {
            window.parent.postMessage(message, '*');
        }
    }
}

export default IframeUtils;
